<template>
  <div
    v-show="isOpen"
    class="fixed top-0 left-0 z-50 w-screen h-screen modal-container modal--row"
    @keyup.esc="$emit('close')"
  >
    <div
      class="modal__inner z-30 md:mx-0 h-full bg-cover overflow-y-scroll relative"
      :class="bg ? bg : ''"
    >
      <span
        class="modular-modal-close absolute z-50 cursor-pointer"
        :class="{ outer: closeLocation === 'outer' }"
        @click.prevent="$emit('close')"
      >
        <svg
          width="29"
          height="30"
          viewBox="0 0 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="28.3536"
            y1="1.35355"
            x2="0.353553"
            y2="29.3536"
            stroke="white"
          />
          <line
            x1="0.353553"
            y1="0.646447"
            x2="28.3536"
            y2="28.6464"
            stroke="white"
          />
        </svg>
      </span>
      <slot></slot>
    </div>
    <div
      v-if="isOpen"
      class="absolute w-screen h-screen z-10 top-0 left-0"
      @click.prevent="$emit('close')"
    ></div>
  </div>
</template>
<style lang="scss" scoped>
.modal-container {
  .modal__inner {
    width: calc(100% - 22px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media (min-width: 736px) {
      width: 80vw;
      height: 80vh;
      overflow-y: hidden;
    }

    @media (max-width: 736px) {
      .column {
        margin-bottom: 10px !important;
      }
    }

    .container {
      position: relative;
      z-index: 10;

      @media (min-width: 736px) {
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    .modular-modal-close {
      right: 20px;
      top: 20px;
    }

    &.bg-white {
      .modular-modal-close {
        svg line {
          stroke: theme("colors.blue.dark");
        }
      }
    }
  }
}
</style>
<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    closeLocation: {
      type: String,
      required: false,
      default: "inner"
    },
    bg: {
      type: String,
      required: false,
      default: null
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen === false) {
        window.removeEventListener("keyup", this.onEscapeKeyUp);
      } else {
        window.addEventListener("keyup", this.onEscapeKeyUp);
      }
    }
  },
  methods: {
    onEscapeKeyUp(event) {
      if (event.which === 27) {
        this.$emit("close");
      }
    }
  }
};
</script>
